
import Typography from 'typography'

const typography = new Typography({
    baseFontSize: '18px',
    headerFontFamily: ['Sanchez', 'Helvetica Neue', 'Segoe UI', 'Helvetica', 'Arial', 'sans-serif'],
    bodyFontFamily: ['proxima-nova', 'serif'],
    // See below for the full list of options.
});

export default typography;

// Or insert styles directly into the <head> (works well for client-only
// JS web apps.
//typography.injectStyles()


// WEBPACK FOOTER //
// ./src/utils/typography.js